import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";

export const Container=styled(Box)(()=>({
    backgroundColor:"#D7C21B",
    padding:"33px 0px",
    scrollMarginTop:"30px",
}));

export const ExperienceContainer=styled(Box)(()=>({
    display:"flex",
    flexDirection:"column",
    alignItems:"center",
    cursor:"pointer"
}));

export const TextContainer=styled(Typography)(()=>({
    color:"#8000a4",
    fontWeight: "bold",
    fontSize: "26px",
    lineHeight:"39px"
}));

export const ValueContainer=styled(Typography)(()=>({
    color:"#003e3e",
    fontWeight: "bold",
    fontSize: "19px",
    lineHeight:"39px"
}));

export const EachExperienceContainer=styled(Box)(({eleRef,showdetails,boxlength})=>({
    transition:"height 1s",
    display:"flex",
    height:showdetails?(eleRef?.current?.scrollHeight ?? 0):0,
    flexDirection:"column",
    gap:"17px",
    overflow:"hidden"
}));

export const EachExperience=styled(Box)(()=>({
    display:"flex",
    alignItems:"center",
    flexWrap:"wrap",
    margin:"0px 1%",
    '&>p':{
        border:"4px solid #ff00a7",
        flex:1,
        padding:"4px",
        whiteSpace:"nowrap"
    }
}));